import type { StyleRule } from '@archipro-design/aria';
import {
    SubheaderClassName,
    textInputSlotClassNames,
} from '@archipro-design/aria';
import { captionClassName } from '@archipro-design/aria';
import { dialogSlotClassNames } from '@archipro-design/aria';
import { buttonClassName, pxToRem } from '@archipro-design/aria';
import { loginModalSlotClassNames } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import { getDvhStyles } from '~/modules/moodboards/util';

export const LoginModal: StyleRule = ({ theme }) => ({
    ...getDvhStyles('height'),
    animation: 'loginModalSlideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1) both',
    [theme.screen.tablet]: {
        height: 'auto',
    },

    [`& .${loginModalSlotClassNames.header}`]: {
        [theme.screen.tablet]: {
            marginBottom: pxToRem(16),
        },
    },
});

/** Extends LoginModal with richer entrance animation and a delayed close button. */
export const LoginModalSiteGate: StyleRule = ({ theme }) => ({
    ...LoginModal({ theme }),
    animation: 'siteGateSlideUp 0.55s cubic-bezier(0.16, 1, 0.3, 1) both',
    [`& .${loginModalSlotClassNames.header} .${buttonClassName}`]: {
        opacity: 0,
        animation: 'closeButtonFadeIn 0.3s ease-out 2s forwards',
    },
});

export const OverlayClass: StyleRule = ({ theme }) => ({
    ...getDvhStyles('height'),
    border: `1px solid ${theme.siteVariables.colors.white['100A']}`,
});

/** Darker backdrop with fade-in for the automatic site gate prompt. */
export const SiteGateOverlay: StyleRule = () => ({
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    animation: 'siteGateBackdropFadeIn 0.4s ease-out both',
});

export const LoginMessage: StyleRule = () => ({
    maxWidth: pxToRem(330),
    margin: 'auto',
    marginTop: pxToRem(-16),
});

export const LoginSubtitle: StyleRule = () => ({
    maxWidth: pxToRem(518),
    margin: 'auto',
    marginTop: pxToRem(-12),
    marginBottom: pxToRem(36),
    textAlign: 'center',
});

export const LoginModalContent: StyleRule = ({ theme }) => ({
    [`& .${SubheaderClassName}`]: {
        textAlign: 'center',
        color: theme.siteVariables.colors.charcoal[250],
        marginBottom: pxToRem(36),
    },
    [`& .${captionClassName}.${textInputSlotClassNames.message}`]: {
        color: theme.siteVariables.colors.danger[300],
    },
});

export const CommonCaption: StyleRule = ({ theme }) => ({
    textAlign: 'center',
    color: theme.siteVariables.colors.charcoal[250],
    marginBottom: pxToRem(36),
});

export const ForgotPasswordModal: StyleRule = ({ theme }) => ({
    [`& .${loginModalSlotClassNames.header}`]: {
        [`& .${buttonClassName}`]: {
            left: pxToRem(8),
            right: 'auto !important',
            [theme.screen.laptop]: {
                left: pxToRem(18),
            },

            [`& .${svgIconClassName}`]: {
                height: pxToRem(22),
                width: pxToRem(22),
            },
        },
    },
    [`& .${dialogSlotClassNames.footer}`]: {
        margin: 0,
    },
});

export const FormLink: StyleRule = ({ theme }) => ({
    [`& .${captionClassName}`]: {
        color: theme.siteVariables.colors.charcoal[250],
    },
});
